import React, { Suspense, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { useMediaQuery } from "@mui/material";

import { Link, useParams } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

import { fetchOrderCruiseDetails } from "../../data/cruises/orderCruiseDetailsSlice";

const ThanksCruise = () => {
  const { orderId } = useParams();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery("(max-width:767px)");
  const isTablet = useMediaQuery("(max-width:1024px)");
  const currency = useSelector((state) => state.currency.currency);

  const { orderCruiseDetails, loading, error } = useSelector(
    (state) => state.orderCruiseDetails
  );

  useEffect(() => {
    dispatch(fetchOrderCruiseDetails(orderId));
  }, [orderId, dispatch]);

  return (
    <>
      <Helmet>
        <title>{orderCruiseDetails.pageDetails?.pageMetatagTitle}</title>
        <link
          rel="canonical"
          href={`https://travco.com/en/ThanksCruisesConfirmation/${orderId}`}
        />
        <meta name="robots" content="index, follow" />
        <meta
          name="description"
          content={orderCruiseDetails.pageDetails?.pageMetatagDescription}
        />
        <meta
          property="og:title"
          content={orderCruiseDetails.pageDetails?.metatagTitleFacebook}
        />
        <meta
          property="og:description"
          content={orderCruiseDetails.pageDetails?.metatagDescriptionFacebook}
        />
        <meta
          name="twitter:title"
          content={orderCruiseDetails.pageDetails?.metatagTitleTwitter}
        />
        <meta
          name="twitter:description"
          content={orderCruiseDetails.pageDetails?.metatagDescriptionTwitter}
        />
        <style type="text/css">
          {`

          .form-control{
          height:50px;
          border-color:#0000003b;
          }
             .form-v8-content .form-row .form-row-inner .label {
        position: absolute;
        top: -25px;
      
    }
    .form-v8-content .form-detail .form-row .input-text:focus + .label, .form-v8-content .form-detail .form-row .input-text:valid + .label {
        -webkit-transform: translateY(-10px) scale(1);
    }
    #register, #login {
        display: flex;
        justify-content: space-between !important;
        flex-wrap: wrap !important;
    }
        .react-datepicker-wrapper{
        position:relative;
        width:100%;
        }
        .input-group-prepend span{
        position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
        }
    .react-datepicker-popper{
    z-index: 100}
   @media screen and (min-width:767px){
    .w-45 {
        width: 45% !important;
    }}
        .css-154xyx0-MuiInputBase-root-MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline{
        border-color:#e60000 !important;
        }

   

          `}
        </style>
        <link
          href="TITSolutions/WS/assets/login-booking/css/sourcesanspro-font.css"
          rel="stylesheet"
        />
        <link
          href="TITSolutions/WS/assets/login-booking/css/style.css"
          rel="stylesheet"
        />
        <link
          href="TITSolutions/WS/assets/line-awesome-3.css"
          rel="stylesheet"
        ></link>
      </Helmet>
      <section className="outter">
        <div
          id="rlr_banner_slider"
          className="splide rlr-banner-splide rlr-banner-splide--fullwidth-v2"
        >
          <div className="splide__track rlr-banner-splide__track">
            <ul className="splide__list height-internal-pages">
              <li className="splide__slide height-internal-pages rlr-banner-splide__slide">
                <div className="rlr-banner-splide__image-wrapper height-internal-pages">
                  <div className="overlay-banner"></div>
                  <Suspense fallback={<div>Loading...</div>}>
                    <img
                      src={
                        isMobile
                          ? orderCruiseDetails?.pageDetails?.pageBannerMobile
                          : isTablet
                          ? orderCruiseDetails?.pageDetails?.pageBannerTablet
                          : orderCruiseDetails?.pageDetails?.pageBannerPc
                      }
                      alt={orderCruiseDetails?.pageDetails?.altBanner}
                      loading="lazy"
                    />
                  </Suspense>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section className="payment-area pt-100">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="form-box payment-received-wrap mb-0">
                <div className="form-title-wrap">
                  <div className="step-bar-wrap text-center">
                    <ul
                      className="step-bar-list d-flex align-items-center justify-content-around"
                      style={{ listStyle: "none" }}
                    >
                      <li className="step-bar flex-grow-1 step-bar-active ">
                        <span className="icon-element">
                          {" "}
                          <FontAwesomeIcon icon={faCheck} />
                        </span>
                        <p className="pt-2 color-text-2">Choose Cruise </p>
                      </li>
                      <li className="step-bar flex-grow-1 step-bar-active ">
                        <span className="icon-element">
                          {" "}
                          <FontAwesomeIcon icon={faCheck} />
                        </span>
                        <p className="pt-2 color-text-2">Choose Cabin </p>
                      </li>
                      <li className="step-bar flex-grow-1 step-bar-active ">
                        <span className="icon-element">
                          {" "}
                          <FontAwesomeIcon icon={faCheck} />
                        </span>
                        <p className="pt-2 color-text-2">Checkout </p>
                      </li>
                      <li className="step-bar flex-grow-1 step-bar-active ">
                        <span className="icon-element">
                          {" "}
                          <FontAwesomeIcon icon={faCheck} />
                        </span>
                        <p className="pt-2 color-text-2">Booking Completed! </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="rlr-section">
        <div className="container-xxl">
          <div className="entry-content">
            <div className="woocommerce-info">
              <div className="rlr-page-title">
                <span className="rlr-page-title__icon">
                  {" "}
                  <i className="rlr-icon-font flaticon-seen"> </i>{" "}
                </span>
                <div>
                  <h2 className="type-h3 rlr-page-title__title">
                    Request Received
                  </h2>
                  <span className="rlr-page-title__desc">
                    Thank you, we have recieved your request!
                  </span>
                </div>
              </div>
            </div>
            <div className="rlr-content">
              <div className="woocommerce">
                <div className="  row justify-content-between align-items-baseline">
                  <div className="woocommerce-order-details col-lg-4 mx-0">
                    <h5 className="woocommerce-order-details__title">
                      Travel Information
                    </h5>
                    <address>
                      <ul className="woocommerce-details__items">
                        <li className="woocommerce-details__item">
                          <span className="font-weight-medium ">
                            Origin Name:
                          </span>
                          <span className="text-secondary text-right">
                            {orderCruiseDetails?.orderDetails?.originName}{" "}
                          </span>
                        </li>
                        <li className="woocommerce-details__item">
                          <span className="font-weight-medium ">
                            Arrival Airline:
                          </span>
                          <span className="text-secondary text-right">
                            {orderCruiseDetails?.orderDetails?.arrivalAirline}{" "}
                          </span>
                        </li>
                        <li className="woocommerce-details__item">
                          <span className="font-weight-medium ">
                            Arrival Flight Number:
                          </span>
                          <span className="text-secondary text-right">
                            {
                              orderCruiseDetails?.orderDetails
                                ?.arrivalFlightNumber
                            }{" "}
                          </span>
                        </li>
                        <li className="woocommerce-details__item">
                          <span className="font-weight-medium ">
                            Arrival Date:
                          </span>
                          <span className="text-secondary text-right">
                            {orderCruiseDetails?.orderDetails?.arrivalDate}{" "}
                          </span>
                        </li>
                        <li className="woocommerce-details__item">
                          <span className="font-weight-medium ">
                            Order number:
                          </span>
                          <span className="text-secondary text-right">
                            {orderCruiseDetails?.orderDetails?.orderId}{" "}
                          </span>
                        </li>
                        <li className="woocommerce-details__item">
                          <span className="font-weight-medium ">
                            Order Date:
                          </span>
                          <span className="text-secondary text-right">
                            {orderCruiseDetails?.orderDetails?.orderTripDate}
                          </span>
                        </li>
                      </ul>
                    </address>
                  </div>
                  <div className="woocommerce-order-details col-lg-4 mx-0">
                    <div className="woocommerce-customer-details">
                      <h2 className="woocommerce-column__title">
                        Your Details
                      </h2>
                      <address>
                        <ul className="woocommerce-details__items px-3">
                          <li className="woocommerce-details__item">
                            <span className="woocommerce-details__icon">
                              <i className="rlr-icon-font flaticon-carbon-user">
                                {" "}
                              </i>
                            </span>
                            <div>
                              <p className="woocommerce-details__title">
                                {" "}
                                Name
                              </p>
                              <span className="woocommerce-details__desc">
                                {
                                  orderCruiseDetails.orderDetails
                                    ?.customerFirstName
                                }{" "}
                                {
                                  orderCruiseDetails.orderDetails
                                    ?.customerLastName
                                }
                              </span>
                            </div>
                          </li>

                          <li className="woocommerce-details__item">
                            <span className="woocommerce-details__icon">
                              <i className="rlr-icon-font flaticon-email"> </i>
                            </span>
                            <div>
                              <p className="woocommerce-details__title">
                                Email
                              </p>
                              <span className="woocommerce-details__desc">
                                {" "}
                                {
                                  orderCruiseDetails.orderDetails
                                    ?.customerEmailAddress
                                }{" "}
                              </span>
                            </div>
                          </li>
                          <li className="woocommerce-details__item">
                            <span className="woocommerce-details__icon">
                              <i className="rlr-icon-font flaticon-telephone">
                                {" "}
                              </i>
                            </span>
                            <div>
                              <p className="woocommerce-details__title">
                                Mobile No.
                              </p>
                              <span className="woocommerce-details__desc">
                                {
                                  orderCruiseDetails.orderDetails
                                    ?.customerMobile
                                }
                              </span>
                            </div>
                          </li>

                          {/* <li className="woocommerce-details__item">
                            <span className="woocommerce-details__icon">
                              <i className="rlr-icon-font flaticon-map-marker">
                                {" "}
                              </i>
                            </span>
                            <div>
                              <p className="woocommerce-details__title">
                                Country
                              </p>
                              <span className="woocommerce-details__desc">
                                {orderCruiseDetails.orderDetails?.countryName}
                              </span>
                            </div>
                          </li> */}

                          <li className="woocommerce-details__item">
                            <span className="woocommerce-details__icon">
                              <i className="rlr-icon-font flaticon-right-arrows">
                                {" "}
                              </i>
                            </span>
                            <div>
                              <p className="woocommerce-details__title">
                                Nationality
                              </p>
                              <span className="woocommerce-details__desc">
                                {
                                  orderCruiseDetails.orderDetails
                                    ?.nationalityName
                                }
                              </span>
                            </div>
                          </li>
                        </ul>
                      </address>
                    </div>
                  </div>
                  <div className="woocommerce-order-details col-lg-3 mx-0">
                    <h2 className="woocommerce-order-details__title">
                      Cruise Information
                    </h2>
                    <table className="woocommerce-table woocommerce-table--order-details shop_table order_details">
                      <thead>
                        <tr>
                          <th className="woocommerce-table__product-name product-name">
                            Cruise
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <ul className="order-detail-card">
                              <li className="order-detail-card__item">
                                <strong>Cruise Name :</strong>{" "}
                                {orderCruiseDetails.orderDetails?.cruiseName}
                              </li>
                              <li className="order-detail-card__item">
                                <strong>Cabin :</strong>{" "}
                                {orderCruiseDetails.orderDetails?.cabinName}
                              </li>
                              <li className="order-detail-card__item">
                                <strong>Route :</strong>{" "}
                                {
                                  orderCruiseDetails.orderDetails
                                    ?.itinararyRoute
                                }
                              </li>
                              <li className="order-detail-card__item">
                                <strong>Duration :</strong>{" "}
                                {
                                  orderCruiseDetails.orderDetails
                                    ?.itinararyDuration
                                }
                              </li>

                              <li className="order-detail-card__item">
                                <strong>Check In :</strong>{" "}
                                {orderCruiseDetails.orderDetails?.orderTripDate}
                              </li>
                              <li className="order-detail-card__item">
                                <strong>Check Out :</strong>{" "}
                                {orderCruiseDetails.orderDetails?.checkOut}
                              </li>

                              <li className="order-detail-card__item">
                                <strong>Adults No. :</strong>{" "}
                                {orderCruiseDetails.orderDetails?.adultNo}
                              </li>

                              <li className="order-detail-card__item">
                                <strong>Child No. :</strong>{" "}
                                {orderCruiseDetails.orderDetails?.cruiseChildNo}
                              </li>

                              <li className="order-detail-card__item">
                                <strong>Total :</strong>{" "}
                                <b className="text-travco">
                                  {" "}
                                  <span className="woocommerce-Price-currencySymbol">
                                    {
                                      orderCruiseDetails.orderDetails
                                        ?.payTabCartCurrency
                                    }
                                  </span>{" "}
                                  {
                                    orderCruiseDetails.orderDetails
                                      ?.orderTotalAmount
                                  }
                                </b>
                              </li>
                            </ul>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ThanksCruise;
